import ActionTypes from './actionTypes';

export function getTransactionsAction(payload, isFilterClick=false) {
  payload.sortDirection = payload.sortDirection ? 'ASC' : 'DESC';
  return {
    type: ActionTypes.TRANSACTIONS.REQUEST,
    payload: {
      ...payload,
      isFilterClick,
    }
  };
}

export function getTransactionsSuccess(response) {
  return {
    type: ActionTypes.TRANSACTIONS.SUCCESS,
    payload: {
      transactions: response.fleetTransactions,
      totalSize: response.outObjectCount,
    }
  };
}

export function getTransactionsFailure() {
  return {
    type: ActionTypes.TRANSACTIONS.FAILURE
  };
}

export function getTransactionsReset() {
  return {
    type: ActionTypes.TRANSACTIONS.RESET
  };
}

export function transactionFilter(
  filterTerm,
  accountid,
  contractid,
  cardno,
  drivername,
  vehicleregno,
  sourceno,
  startdate,
  enddate
) {
  return ({
    type: ActionTypes.TRANSACTIONS.FILTER.REQUEST,
    queryParams: {
      filterTerm,
      accountid,
      contractid,
      cardno,
      drivername,
      vehicleregno,
      sourceno,
      startdate,
      enddate
    },
  });
}

export function downloadTransactions(payload) {
  payload.sortDirection = payload.sortDirection ? 'ASC' : 'DESC';
  return ({
    type: ActionTypes.TRANSACTIONS.DOWNLOAD.REQUEST,
    payload: payload
  });
}

export function getTransactionItemsAction(contractAndDoc) {
  return {
    type: ActionTypes.TRANSACTIONITEMS.REQUEST,
    payload: {
      contractAndDoc:contractAndDoc
    }
  };
}

export function getTransactionItemsSuccess(response) {
  return {
    type: ActionTypes.TRANSACTIONITEMS.SUCCESS,
    payload: {
      transactionItems: response.fleetTransactionItems,
      totalSize: response.outObjectCount,
    }
  };
}

export function getTransactionItemsFailure() {
  return {
    type: ActionTypes.TRANSACTIONITEMS.FAILURE
  };
}
